'use strict';
var currLayout;
function initCurrentLayout() {
	if (window.innerWidth >= 769) {
		return currLayout = "desktop"
	} else {
		return currLayout = "mobile"
	}
}

export default {
	init: function () {
		return initCurrentLayout();
	}
};